// src/pages/dashboard/dateUtils.js
import dayjs from "dayjs";
import isoWeek from "dayjs/plugin/isoWeek";

// Extend dayjs dengan plugin week
dayjs.extend(isoWeek);

/**
 * Mendapatkan nama hari dalam bahasa Indonesia
 * @param {dayjs.Dayjs} date - Objek dayjs
 * @returns {string} Nama hari
 */
export const getDayName = (date) => {
    const days = ["Mig", "Sen", "Sel", "Rab", "Kam", "Jum", "Sab"];
    return days[date.day()];
};

/**
 * Mendapatkan nama bulan dalam bahasa Indonesia
 * @param {dayjs.Dayjs} date - Objek dayjs
 * @returns {string} Nama bulan
 */
export const getMonthName = (date) => {
    const months = ["Jan", "Feb", "Mar", "Apr", "Mei", "Jun", "Jul", "Agu", "Sep", "Okt", "Nov", "Des"];
    return months[date.month()];
};

/**
 * Mendapatkan week number (ISO week)
 * @param {dayjs.Dayjs} date - Objek dayjs
 * @returns {number} Nomor minggu
 */
export const getWeekNumber = (date) => {
    return date.isoWeek();
};

/**
 * Memformat tanggal untuk ditampilkan
 * @param {dayjs.Dayjs} date - Objek dayjs (default: hari ini)
 * @returns {Object} Objek dengan informasi tanggal yang diformat
 */
export const formatDate = (date = dayjs()) => {
    const dayName = getDayName(date);
    const day = date.date().toString().padStart(2, "0");
    const monthName = getMonthName(date);
    const year = date.year();
    const weekNumber = getWeekNumber(date);

    return {
        display: `${dayName}, ${day} ${monthName} ${year}`,
        week: weekNumber,
        day: day,
        month: monthName,
        year: year,
    };
};

/**
 * Mendapatkan salam berdasarkan waktu
 * @returns {string} Salam yang sesuai
 */
export const getGreeting = () => {
    const now = new Date();
    const hours = now.getHours();
    const minutes = now.getMinutes();
    const currentTime = hours + minutes / 100;

    if (currentTime >= 5.0 && currentTime < 11.0) {
        return "Selamat Pagi";
    } else if (currentTime >= 11.0 && currentTime < 15.0) {
        return "Selamat Siang";
    } else if (currentTime >= 15.0 && currentTime < 18.0) {
        return "Selamat Sore";
    } else if (currentTime >= 18.0 && currentTime < 22.0) {
        return "Selamat Malam";
    } else {
        return "Waktunya Tidur";
    }
};

export default {
    getDayName,
    getMonthName,
    getWeekNumber,
    formatDate,
    getGreeting
};